import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "btn btn-link btn-sm" }
const _hoisted_6 = { class: "btn btn-link btn-sm" }
const _hoisted_7 = {
  class: "container",
  style: {"margin-bottom":"40px"}
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "card bg-light" }
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "card-text" }
const _hoisted_14 = ["href"]

import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import { useOrganizationUnitsQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageOrganizationsPage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    const {
        modelOrganizationUnitsQueryV1,
        runOrganizationUnitsQueryV1
    } = useOrganizationUnitsQueryV1()

    onMounted(() =>
    {
        document.title = 'Manage organizations'
        runOrganizationUnitsQueryV1()
    })

    const organizations = computed(() => modelOrganizationUnitsQueryV1.value?.OrganizationUnits ?? [])

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Manage organizations", -1 /* CACHED */)),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-exchange",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Change user's organization ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/admin/organizations/users/manage/organization`]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "fa fa-user-secret",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Assign Global Admin ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/admin/organizations/users/manage/roles`]
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, [
          _createElementVNode("a", {
            href: `/#/admin/organizations/create`,
            role: "button",
            class: "btn btn-success text-white",
            style: {"padding":"0.7em 2em"}
          }, [
            _createElementVNode("i", {
              class: "fa fa-plus",
              "aria-hidden": "true"
            }),
            _createTextVNode(" New organization ")
          ])
        ], -1 /* CACHED */))
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (o) => {
          return (_openBlock(), _createElementBlock("div", {
            key: o.OrganizationUnitId,
            class: "col-md-4 col-sm-6",
            style: {"margin-bottom":"20px"}
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", {
                  href: `/#/admin/organizations/dashboard/${o.OrganizationUnitId}`
                }, _toDisplayString(o.Name), 9 /* TEXT, PROPS */, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(o.Description || 'No description'), 1 /* TEXT */),
                _createElementVNode("p", null, [
                  _createTextVNode(" Admins count: " + _toDisplayString(o.AdminsCount), 1 /* TEXT */),
                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("a", {
                    href: `/#/admin/organizations/users/createorganizationadmin/${o.OrganizationUnitId}`,
                    class: "card-link"
                  }, "Set up admin", 8 /* PROPS */, _hoisted_14)
                ])
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

})